module.exports = __webpack_public_path__ + "img/企業行銷會員.38eeff60.svg";